import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PseudoSelect from './pseudo-select';
import StandardPackage from './standard-package';

class Component extends BaseComponent {
    render({ state_upc, upc, packages }) {
        if (packages) {
            if (packages.length > 1) {
                return (
                    <power-package>
                        <div className='icon-discount-fifty-percent is-hidden-mobile' />
                        <row>
                            <column className='is-2'>
                                <div className={`pseudo-radio ${state_upc === upc ? 'checked' : null}`}>
                                    <input
                                        type='radio'
                                        name='upc'
                                        value={upc}
                                        onClick={this.trackChange}
                                        checked={state_upc == upc}
                                    />
                                </div>
                            </column>
                            <column className='is-10'>
                                <label>
                                    <select
                                        active={state_upc == upc}
                                        onChange={this.trackChange}
                                        onFocus={this.trackFocus}
                                    >
                                        {packages.map((pkg) => (this.renderOption(pkg, state_upc, upc)))}
                                    </select>
                                    <PseudoSelect />
                                </label>
                            </column>
                        </row>
                    </power-package>
                );
            }

            const pkg = packages[0];
            return (
                <power-package>
                    <div className='icon-discount-fifty-percent is-hidden-mobile' />
                    <StandardPackage
                        upc={pkg.upc}
                        coins={pkg.paid_kcs + pkg.free_kcs}
                        price={pkg.usd.current}
                        percent={pkg.percent}
                    />
                </power-package>
            );
        }

        return (
            <power-package />
        );
    }

    renderOption(pkg, state_upc, upc) {
        return (
            <option value={pkg.upc} selected={pkg.upc == upc}>
                {pkg.free_kcs + pkg.paid_kcs} Karma Coins - ${pkg.usd.current}
            </option>
        );
    }

    trackChange = (e) => {
        this.trackEvent(`Click-${e.target.value}`);
        this.props.setPowerUPC(e.target.value);
    }

    trackFocus = (e) => {
        this.trackEvent('Reveal-Power-Packages');
        this.props.setPowerUPC(e.target.value);
    }

    trackEvent = (action) => {
        let label = 'logged-out';

        if (this.props.logged_in) {
            label = this.props.sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
        }

        this.props.trackEvent([ 'kc-store', action, label ]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    state_upc: state['karmacoin-store'].upc,
    upc: state['karmacoin-store'].power_upc,
    packages: state['karmacoin-store'].packages && state['karmacoin-store'].packages.power,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    setPowerUPC: (upc) => dispatch({
        type: 'karmacoin-store:update',
        payload: {
            power_upc: upc,
            upc: upc,
        },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
